module.exports = __webpack_public_path__ + "static/Celebrate-Small-3ba94c820b25e7cf143a9a1ea385baa8.png";